// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fw6EL","colBig":"styles_colBig__1rcWq","colSmall":"styles_colSmall__2wnhE"};